import Header from "../header/Header";
import DashboardLayout from "../layout";
// import { PiDotsThreeVerticalBold } from "react-icons/pi"
import "../../App.css"

function Quoteadmindetails() {

    const obj = {
        ative: true,
        content: "Qoute# Pk3445555"
    }

    return (
        <>
            <DashboardLayout>
                {/* <div className="h-full sm:block hidden border-r  " >
                    <SideBar obj={obj} />
                </div> */}
                <div className="w-full" >
                    <Header title="Qoute# Pk3445555" />

                    <div className="p-2  bg-cus-gray ">


                        <div className="flex flex-col w-ful bg-white rounded-md md:py-5 py-3 px-0  items-center mt-4 justify-between">
                            <div className="w-full bg-white rounded-md md:p-5 p-3 flex flex-col gap-y-4 md:flex-row items-center justify-between">
                                <p className="text-bold text-[16px] font-medium">Qoute# Pk3445555</p>

                                <div
                                    className="cursor-pointer flex justify-center items-center gap-x-3 w-full md:w-[192px] text-[#DA1C00] border border-[#DA1C00] h-[50px] bg-[#DA1C0008]  p-2 rounded-md text-sm">
                                    {/* <span className="bg-white text-cus-red rounded-full px-1 me-1">+</span> */}
                                    <img src="/pdf.svg" alt=" right-0" />
                                    <p>Download Pdf</p>
                                </div>



                            </div>
                            {/* for web */}
                            <div className="hidden  sm:inline  w-full">

                                <table className=" w-full text-sm text-center ">
                                    <thead className="text-[#181823] font-normal">
                                        <tr className="border-b-2 ">
                                            <th className="p-1">Qoute Name</th>
                                            <th className="p-1">Date</th>
                                            <th className="p-1">Price</th>
                                            <th className="p-1">Country</th>
                                            <th className="p-1">Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody className="">

                                        <tr className="text-[#1818239E]">

                                            <td className="p-2">Lorem Ipsum</td>
                                            <td className="p-2">12 July, 2023</td>
                                            <td className="p-2">$ 134.00</td>
                                            <td className="p-2">United States</td>
                                            <td className="p-2">$76777.00</td>

                                        </tr>

                                        <tr className="bg-[#053F923D]  text-[#1818239E]">

                                            <td className="p-2"></td>
                                            <td className="p-2"></td>
                                            <td className="p-2"></td>
                                            <td className="p-2 flex flex-col ">
                                                {/* <p className="text-[#1818239E]">Subtotal</p> */}

                                                <p className=" text-[#181823]">Grand Total</p>
                                            </td>
                                            <td className="p-2">
                                                {/* <p className="text-[#1818239E]">$6777</p> */}

                                                <p className=" text-[#181823]">$899999</p>
                                            </td>

                                        </tr>







                                    </tbody>
                                </table>
                            </div>
                            {/* for mobile */}
                            <div className=" p-4 sm:hidden  w-full">
                                {/* 1st card */}
                                <div className=" flex wrap    justify-between items-center  mt-3 w-full  sm:px-auto">
                                    <div className="flex-wrap">
                                        <p className="font-semibold text-lg">Qoute Name</p>
                                        <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                                            Lorem Ipsum
                                        </p>
                                    </div>
                                    <div className="flex-wrap">
                                        <p className="font-semibold text-lg">Date</p>
                                        <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                                            12 July, 2023
                                        </p>
                                    </div>


                                </div>
                                <div className=" flex wrap   justify-between items-center pb-3  w-full  ">
                                    <div className="flex-wrap">
                                        <p className="font-semibold text-lg">Price</p>
                                        <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                                            $ 134.00
                                        </p>
                                    </div>
                                    <div className="flex-wrap">
                                        <p className="font-semibold text-lg">Country</p>
                                        <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                                            United States
                                        </p>
                                    </div>



                                </div>
                                <div className=" flex wrap   justify-between items-center pb-3  w-full  ">
                                    <div className="flex-wrap">
                                        <p className="font-semibold text-lg">Subtotal</p>
                                        <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                                            $ 134.00
                                        </p>
                                    </div>
                                    <div className="flex-wrap">
                                        <p className="font-semibold text-lg">Grand Total</p>
                                        <p className="font-[600] text-blue-600 text-lg max-w-xs break-all">
                                            $899999
                                        </p>
                                    </div>



                                </div>


                                {/* 2ndcard */}





                            </div>
                        </div>


                    </div>

                </div>

            </DashboardLayout>
        </>
    );
}

export default Quoteadmindetails;